/**
 * LedPanel — 3 LEDs verticais com efeito Knight Rider bounce.
 *
 * Usado nos botões SOAP / PLANTÃO / VOZ do Header pra indicar estado.
 * CSS keyframes vivem em `styles/global.css` (kr-green, kr-amber, kr-red, kr-green-rec).
 *
 * Variants:
 *   - 'off'     → 3 LEDs apagados
 *   - 'green'   → KR verde 1.8s suave (SOAP ON, PLANTÃO ON, VOZ conectado)
 *   - 'amber'   → KR amarelo 1.2s médio (VOZ conectando)
 *   - 'red'     → KR vermelho 0.9s urgente (VOZ desconectado)
 *   - 'green-rec' → KR verde 0.6s rápido (VOZ gravando)
 *
 * Acessibilidade: respeita `prefers-reduced-motion` via @media query global.
 */
export type LedVariant = 'off' | 'green' | 'amber' | 'red' | 'green-rec';

interface LedPanelProps {
  readonly variant?: LedVariant;
}

const VARIANT_CLASS: Record<LedVariant, string> = {
  off: '',
  green: 'kr-green',
  amber: 'kr-amber',
  red: 'kr-red',
  'green-rec': 'kr-green-rec',
};

export function LedPanel({ variant = 'off' }: LedPanelProps) {
  const krClass = VARIANT_CLASS[variant];
  const className = krClass ? `led-col ${krClass}` : 'led-col';
  return (
    <span className={className} aria-hidden="true">
      <span className="led" />
      <span className="led" />
      <span className="led" />
    </span>
  );
}

export default LedPanel;
